<!-- <span class="pre-loader" *ngIf="loading"></span> -->

<app-home> </app-home>

<app-message-dialog *ngIf="isShowMessagePopup" (closeDialog)="onClose($event)" [message]="popupMessage"
  [isSuccess]="true" [popupButtonName]="'Ok'"></app-message-dialog>